{
  "nav": {
    "home": "Início",
    "silos": "Silos",
    "skills": "Skills",
    "arena": "Arena",
    "aiPowered": "Alimentado por IA",
    "knowledgeFlows": "O conhecimento flui inteligentemente pela sua organização.",
    "askTheKnowledgeBase": "Consulte a base de conhecimento",
    "ask": "Consultar",
    "help": "Ajuda",
    "logout": "Terminar sessão",
    "signIn": "Iniciar sessão",
    "openProfileInMe": "O seu perfil em JoyIA Me"
  },
  "common": {
    "loading": "Carregando...",
    "error": "Erro",
    "save": "Salvar",
    "saving": "Salvando...",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "edit": "Editar",
    "hide": "Ocultar",
    "create": "Criar",
    "search": "Pesquisar",
    "filter": "Filtrar",
    "refresh": "Atualizar",
    "close": "Fechar",
    "back": "Voltar",
    "next": "Próximo",
    "previous": "Anterior",
    "submit": "Enviar",
    "confirm": "Confirmar",
    "yes": "Sim",
    "no": "Não",
    "all": "Todos",
    "none": "Nenhum",
    "select": "Selecionar",
    "viewAll": "Ver tudo",
    "remove": "Remover",
    "add": "Adicionar",
    "new": "Novo",
    "success": "Sucesso",
    "warning": "Aviso",
    "info": "Informação",
    "noResults": "Nenhum resultado encontrado",
    "noData": "Gerencie os seus silos de conhecimento e pesquise em todos os conteúdos",
    "clear": "Limpar",
    "sync": "Sincronizar",
    "item": "elemento",
    "items": "elementos",
    "copied": "Copiado!"
  },
  "silos": {
    "title": "Silos",
    "description": "Silos de conhecimento e coleções de documentos",
    "createNew": "Criar novo Silo",
    "editSilo": "Editar Silo",
    "deleteSilo": "Excluir Silo",
    "siloSettings": "Configurações do Silo",
    "knowledge": "Conhecimento",
    "project": "Projeto",
    "timeline": "Cronograma",
    "sync": "Sincronizar",
    "syncHistory": "Histórico de sincronização",
    "connectors": "Conectores",
    "statusLabel": "Status",
    "idle": "Ocioso",
    "running": "Em execução",
    "pending": "Pendente",
    "error": "Erro",
    "newSilo": "Novo Silo",
    "createSilo": "Criar Silo",
    "myKnowledgeBase": "A minha base de conhecimento",
    "sortByName": "Nome (A–Z)",
    "sortByCreated": "Criados recentemente",
    "heading": "Silos de conhecimento",
    "unitSingular": "silo",
    "searchPlaceholder": "Procurar silos...",
    "emptyTitle": "Ainda não existem silos de conhecimento",
    "emptyBody": "Crie o seu primeiro silo para começar a construir a sua base de conhecimento"
  },
  "skills": {
    "title": "Skills",
    "description": "Habilidades e capacidades",
    "createNew": "Criar nova habilidade",
    "editSkill": "Editar habilidade",
    "deleteSkill": "Excluir habilidade",
    "arena": "Arena",
    "skillDetails": "Detalhes da habilidade",
    "knowledge": "Conhecimento",
    "project": "Projeto",
    "mine": "As minhas Skills",
    "unitSingular": "skill",
    "newSkill": "Nova Skill",
    "searchPlaceholder": "Procurar skills…",
    "allCategories": "Todas as categorias",
    "emptyTitle": "Nenhuma skill encontrada",
    "emptyBody": "Crie a sua primeira skill ou importe uma do GitHub ou skills.sh",
    "sharedWithTribes": "Compartilhadas com Tribes",
    "thisTribeHint": "Skills compartilhadas com esta Tribe. Abra uma skill para ver as instruções de instalação.",
    "sharedTribesHint": "Skills compartilhadas com as Tribes das quais você faz parte. Abra uma skill para ver as instruções de instalação.",
    "showAllTribes": "Mostrar todas as minhas Tribes",
    "loadFailed": "Não foi possível carregar as skills. Recarregue a página.",
    "sharedEmptyBody": "Ainda não foram partilhados skills aqui. Pede a um membro da tribe para partilhar um.",
    "categoryEmptyBody": "Nenhum skill corresponde à categoria «{{category}}».",
    "allSkills": "Todos os skills",
    "collections": "Coleções de skills",
    "allSources": "Todas as fontes",
    "source": "Fonte",
    "noMatchesBody": "Tenta uma pesquisa diferente ou remove os filtros.",
    "clearFilters": "Remover filtros"
  },
  "visibility": {
    "private": "Privado",
    "privateDesc": "Apenas você pode acessar",
    "orgVisible": "Visível para a organização",
    "orgVisibleDesc": "Qualquer um em sua organização",
    "restricted": "Restrito",
    "restrictedDesc": "Pessoas que você convida",
    "tribe": "Tribe",
    "tribeDesc": "Todos os membros de uma tribe",
    "label": "Visibilidade",
    "public": "Público"
  },
  "classification": {
    "unclassified": "Não classificado",
    "confidential": "Confidencial",
    "strictlyConfidential": "Estritamente confidencial"
  },
  "sources": {
    "github": "GitHub",
    "internal": "Interno",
    "skillSh": "skills.sh"
  },
  "ask": {
    "title": "Consultar",
    "askAboutThisSilo": "Faça perguntas sobre este silo… (Enter para enviar)",
    "askAcrossAllSilos": "Faça perguntas sobre todos os silos… (Enter para enviar)",
    "askAboutKnowledgeflow": "Faça perguntas sobre Knowledgeflow… (Enter para enviar)",
    "askAQuestion": "Faça uma pergunta sobre esta base de conhecimento...",
    "phAsk": "Pergunte em todos os silos… (Enter para enviar, Shift+Enter para uma nova linha)",
    "synthesised": "As respostas são sintetizadas a partir dos silos de conhecimento a que tem acesso, com pesquisa baseada em IA"
  },
  "settings": {
    "movedToMe": "O seu perfil está agora em JoyIA Me. A redirecioná-lo…",
    "movedToMeNoUrl": "O seu perfil está agora em JoyIA Me."
  },
  "errors": {
    "loadingFailed": "Falha ao carregar",
    "saveFailed": "Falha ao salvar",
    "deleteFailed": "Falha ao excluir",
    "invalidInput": "Entrada inválida",
    "unauthorized": "Você não está autorizado",
    "notFound": "Não encontrado",
    "serverError": "Erro do servidor",
    "failed": "Erro: {{message}}"
  },
  "forms": {
    "required": "Obrigatório",
    "optional": "Opcional",
    "selectOne": "Selecione um...",
    "selectMultiple": "Selecione vários...",
    "enterText": "Digite o texto...",
    "enterNumber": "Digite um número...",
    "chooseFile": "Escolher arquivo...",
    "dragDropFiles": "Arraste e solte arquivos aqui",
    "or": "ou",
    "browseFiles": "procurar arquivos",
    "description": "Descrição"
  },
  "pagination": {
    "previous": "Anterior",
    "next": "Próximo",
    "of": "de",
    "page": "Página",
    "rowsPerPage": "Linhas por página"
  },
  "dialogs": {
    "confirmDelete": "Confirmar exclusão",
    "areYouSure": "Tem certeza de que deseja excluir este item?",
    "thisCannotBeUndone": "Esta ação não pode ser desfeita.",
    "deleteConfirm": "Excluir"
  },
  "empty": {
    "noSilos": "Ainda não há silos",
    "noSkills": "Ainda não há habilidades",
    "noResults": "Nenhum resultado encontrado"
  },
  "home": {
    "searchPlaceholder": "Procurar em todos os silos...",
    "noSearchResults": "Nenhum resultado encontrado",
    "totalItems": "Total de elementos",
    "totalMembers": "Total de membros",
    "recentSilos": "Silos recentes",
    "noSilos": "Ainda não existem silos.",
    "createOne": "Criar um",
    "recentItems": "Elementos de conhecimento recentes",
    "knowledgeHealth": "Estado do conhecimento",
    "noItemsFromSource": "Nenhum elemento desta origem"
  },
  "siloView": {
    "abstractSaved": "Resumo salvo",
    "abstractSaveFailed": "Falha ao salvar resumo: {{message}}",
    "siloUpdated": "Silo atualizado",
    "siloUpdateFailed": "Falha ao atualizar silo: {{message}}",
    "syncFailed": "Não foi possível iniciar a sincronização: {{message}}",
    "generatingAbstractBackground": "Gerando resumo em segundo plano…",
    "abstractDrafted": "Resumo rascunho — revise e salve",
    "abstractGenerateFailed": "Falha ao gerar resumo: {{message}}",
    "editSilo": "Editar silo",
    "members": "Membros",
    "config": "Configuração",
    "syncHistory": "Histórico de sincronização",
    "treeView": "Visualização em árvore",
    "mergeSilo": "Mesclar silo",
    "triggerSync": "Disparar sincronização agora",
    "syncing": "Sincronizando…",
    "abstractPlaceholder": "Escreva um breve resumo do que este silo contém...",
    "editAbstract": "Editar resumo",
    "regenerateWithAI": "Regenerar com IA",
    "generatingAbstract": "Gerando resumo…",
    "addSummary": "+ Adicione um resumo para este silo...",
    "generate": "Gerar",
    "generateWithAI": "Gerar resumo com IA",
    "cliSetupInstructions": "Instruções de configuração da CLI",
    "itemsInSilo": "{{count}} itens neste silo",
    "cliProjectSilo": "Silo de projeto acionado pela CLI",
    "linkSiloToProject": "Vincule este silo a um diretório de projeto para que seus agentes de IA possam ler e escrever durante o desenvolvimento.",
    "step1": "1. Vincular ao seu projeto",
    "runInProjectDir": "Execute isto no diretório do seu projeto para vincular este silo.",
    "step2": "2. Sincronize seus arquivos de projeto",
    "syncDescription": "Ingere o contexto do seu projeto (README, documentos, configuração) neste silo. Idempotente — arquivos não alterados são ignorados.",
    "step3": "3. Enviar uma nota única",
    "pushDescription": "Adiciona um item. Ambos os argumentos são obrigatórios — ou envie um arquivo como conteúdo:",
    "step4": "4. Usar com agentes de IA",
    "aiAgentsDescription": "Uma vez vinculado, os agentes de codificação de IA (Claude Code, OpenCode, etc.) podem acessar automaticamente o conhecimento deste silo através do servidor MCP.",
    "state_active": "Ativo",
    "state_paused": "Pausado",
    "state_archived": "Arquivado",
    "lastSync": "Última sincronização: {{time}}",
    "syncOverdue": "Sincronização vencida",
    "nextSync": "Próxima sincronização em {{label}}",
    "source": "Origem",
    "sortNewest": "Mais recentes primeiro",
    "sortImportance": "Maior importância",
    "sortAccessed": "Mais acessados",
    "noItemsYet": "Nenhum item de conhecimento ainda",
    "noItemsHelp": "Adicione itens manualmente ou configure fontes de sincronização",
    "noItemsOfType": "Nenhum item {{type}} encontrado",
    "clearFilter": "Limpar filtro",
    "mergeDialog": "Mesclar outro silo neste",
    "mergeDescription": "Todos os itens do silo selecionado serão movidos para {{name}}.",
    "sourceSilo": "Silo de origem",
    "selectSiloMerge": "Selecione um silo para mesclar...",
    "deleteSourceAfterMerge": "Excluir silo de origem após mesclar",
    "mergeSuccess": "{{count}} itens mesclados com sucesso.{{deleted}}",
    "mergeFailed": "Falha ao mesclar: {{message}}",
    "merging": "Mesclando...",
    "merge": "Mesclar",
    "editSiloDialog": "Editar silo",
    "tags": "Tags (separadas por vírgula)",
    "publicSilo": "Silo público",
    "publicSiloDescription": "Todos os usuários da sua organização podem ler este silo",
    "guardrailProfiles": "Perfis de guardrail",
    "guardrailDescription": "Aplicado a todas as chamadas LLM que processam o conteúdo deste silo",
    "linkToProject": "Vincular ao projeto (CLI)",
    "linkSharedSilo": "Vincular como silo compartilhado",
    "attachSiloDescription": "Vincule este silo a um diretório de projeto como {{role}}, junto ao silo principal do projeto. Vinculado somente leitura — os agentes de IA podem ler, mas as gravações vão para o silo principal do projeto.",
    "timelineSiloLabel": "um silo \"timeline\" compartilhado (atividade recente)",
    "knowledgeSiloLabel": "um silo \"conhecimento\" compartilhado",
    "linkLimits": "Um projeto pode vincular um silo principal mais até 5 silos somente leitura (um de conhecimento, um de timeline, mais silos adicionais somente leitura).",
    "healthAllClear": "Saúde do conhecimento: tudo limpo",
    "avgImportance": "Importância média: {{value}}",
    "staleItem": "item",
    "staleItems": "itens",
    "conflict": "conflito",
    "multiConflicts": "conflitos",
    "archiveStale": "Arquivar {{count}} vencidos",
    "archiveConfirm": "Arquivar {{count}} itens?",
    "runInProjectDirLabel": "Executar no diretório do projeto",
    "staleItemsLabel": "itens",
    "staleItemsList": "{{count}} {{type}} vencidos",
    "archivedStale": "{{count}} itens obsoletos arquivados",
    "conflicts": "{{count}} {{type}}"
  },
  "siloHealth": {
    "authExpiredTitle": "Um conector já não consegue iniciar sessão",
    "authExpiredBody": "As credenciais guardadas de {{sources}} expiraram — normalmente porque a palavra-passe da conta ligada foi alterada. Até a fonte ser novamente ligada, nenhum conteúdo novo chega a este silo.",
    "syncFailingTitle": "Um conector não consegue sincronizar",
    "syncFailingBody": "A última sincronização de {{sources}} falhou, por isso nenhum conteúdo novo está a chegar a este silo.",
    "openSyncSettings": "Abrir as definições de sincronização",
    "unindexedTitle": "O conteúdo deste silo não é pesquisável",
    "thinTitle": "Apenas parte deste silo é pesquisável",
    "coverageBody": "{{indexed}} de {{total}} itens estão no índice de pesquisa ({{pct}}%). As perguntas feitas a este silo — incluindo a partir de qualquer site ligado a ele — são respondidas apenas com essa parte, e nenhum erro é comunicado.",
    "rebuildIndex": "Reconstruir o índice nas definições de sincronização"
  },
  "chart": {
    "noData": "Sem dados para mostrar",
    "fullscreen": "Ecrã inteiro",
    "expandedFullscreen": "Gráfico expandido para ecrã inteiro",
    "closeFullscreen": "Fechar ecrã inteiro"
  },
  "apps": {
    "title": "Apps e origens",
    "description": "Explore os elementos de conhecimento pela origem que os criou",
    "noItems": "Ainda não existem elementos de conhecimento",
    "lastUsed": "Última utilização"
  },
  "skillShare": {
    "title": "Partilhar Skill",
    "description": "Escolha quem pode ver e instalar esta skill.",
    "visibilitySet": "Visibilidade definida como {{value}}",
    "updateFailed": "Não foi possível atualizar a visibilidade: {{message}}",
    "selectTribes": "Selecione as tribos que podem ver esta skill",
    "noTribes": "Nenhuma tribo disponível",
    "selectAtLeastOne": "Selecione pelo menos uma tribo para guardar"
  },
  "skillDetail": {
    "installTracked": "Instalação registada",
    "refreshedWithFiles": "Atualizado — {{count}} novo ficheiro{{plural}} incluído a partir da origem",
    "refreshedFiles": "Atualizado a partir da origem — {{count}} ficheiros",
    "refreshedFromSource": "Atualizado a partir da origem",
    "skillDeleted": "Skill eliminada",
    "skillUpdated": "Skill atualizada",
    "share": "Share",
    "refreshing": "Refreshing…",
    "refresh": "Refresh",
    "skillNotFound": "Skill não encontrada",
    "backToSkills": "Voltar a Skills",
    "public": "Public",
    "sharedWithTribe": "Partilhada com o tribe",
    "private": "Private",
    "installs": "installs",
    "skillAdded": "Skill adicionada!",
    "wantToTestInArena": "Quer ver como se comporta na Arena?",
    "testInArena": "Testar na Arena",
    "editSkill": "Editar skill",
    "name": "Name",
    "version": "Version",
    "description": "Description",
    "content": "Content",
    "categories": "Categories",
    "extraTags": "Etiquetas adicionais",
    "commaSeparated": "separados por vírgulas",
    "tagsPlaceholder": "swiftui, performance",
    "visibility": "Visibility",
    "saving": "Saving…",
    "saveChanges": "Guardar alterações",
    "pluginCapabilities": "Capacidades do plugin",
    "providesTools": "Fornece ferramentas",
    "dependencies": "Dependencies",
    "readinessCheck": "Verificação de prontidão",
    "requiredEnvironment": "Ambiente necessário",
    "required": "Required",
    "nightWatchHooks": "Hooks do Night Watch",
    "notEvaluatedYet": "Ainda não avaliada",
    "runThroughArena": "Passe esta skill pela arena para avaliar até que ponto um modelo a segue.",
    "runArenaTest": "Executar o teste na arena",
    "arenaScore": "Arena Score",
    "testAgain": "Testar novamente",
    "evaluations": "evaluation",
    "lastTested": "último teste",
    "hideHistory": "Ocultar o histórico",
    "showAllEvaluations": "Mostrar todas as {{count}} avaliações",
    "useThisSkill": "Usar esta skill",
    "files": "files",
    "copyCommand": "Copiar o comando",
    "writesSKillMd": "Escreve o SKILL.md e ainda",
    "bundledFile": "ficheiro incluído",
    "copyingGivesYou": "— ao copiar o conteúdo abaixo obtém apenas o SKILL.md.",
    "copySKillMd": "Copiar SKILL.md",
    "tracking": "Tracking…",
    "trackInstall": "Registar a instalação",
    "preferredJoyiaCli": "Recomendado — CLI da Joyia",
    "setup": "Setup",
    "copy": "Copy",
    "opensInteractiveSkillBrowser": "Abre o explorador interativo de skills. Prima",
    "toInstall": "para instalar.",
    "installsFromSkillsSh": "Instala a partir do skills.sh — não é necessária uma conta Joyia.",
    "installFromJoyiaMarketplace": "Instale a partir do marketplace da Joyia através do ID.",
    "manualInstall": "Instalação manual (sem a CLI da Joyia)",
    "install": "Install",
    "cliTab": "CLI",
    "personalTab": "Personal",
    "projectTab": "Project",
    "npxSkillsInstall": "npx skills install",
    "npxSkillsAdd": "npx skills add",
    "step1AddMarketplace": "Passo 1 — adicionar o marketplace",
    "step2InstallPlugin": "Passo 2 — instalar o plugin",
    "copyJSON": "Copiar JSON",
    "skillContent": "Conteúdo da skill",
    "copyRaw": "Copiar em bruto",
    "noContent": "_No content_",
    "bundledFiles": "Ficheiros incluídos",
    "alongsideSKillMd": "juntamente com SKILL.md",
    "collapse": "Collapse",
    "expand": "Expand",
    "deleting": "Deleting…",
    "confirmDelete": "Confirmar eliminação"
  },
  "sharepoint": {
    "connected": "Conectado ao Microsoft SharePoint",
    "signInFailed": "Falha ao fazer login",
    "completingSignIn": "Concluindo login na Microsoft…",
    "redirecting": "Conectado — redirecionando…",
    "error": "Falha ao fazer login",
    "backToSilos": "Voltar para Silos"
  },
  "auth": {
    "subtitle": "Memória persistente para seus agentes de IA e fluxos de trabalho de desenvolvimento",
    "signInWithPia": "Fazer login com PIA"
  },
  "askPanel": {
    "search": "Pesquisar",
    "ask": "Perguntar",
    "searchFailed": "Pesquisa falhou",
    "failedToGetAnswer": "Não foi possível obter a resposta",
    "semanticSearchPlaceholder": "Pesquisa semântica...",
    "focusInTree": "Focar na árvore",
    "askPlaceholder": "Faça uma pergunta sobre esta base de conhecimento...",
    "answer": "Resposta",
    "sources": "Fontes"
  },
  "skillsArena": {
    "title": "Arena de Habilidades",
    "description": "Teste e compare habilidades — os resultados são salvos e classificados",
    "evaluateLabel": "Avaliar uma Habilidade",
    "selectSkill": "Selecione uma habilidade do catálogo ou da classificação abaixo para avaliá-la.",
    "testPromptLabel": "Prompt de Teste",
    "testPromptPlaceholder": "Digite um prompt de teste...",
    "evaluating": "Avaliando... (isso pode levar 30-60s)",
    "evaluateButton": "Avaliar Habilidade",
    "scoreMax": "Pontuação / 100",
    "adherenceMax": "Aderência / 10",
    "duration": "Duração",
    "criteria": "Critérios",
    "generatedOutput": "Saída Gerada",
    "model": "Modelo",
    "judge": "Juiz",
    "savedToRankings": "Salvo na classificação",
    "viewInLibrary": "Ver na Biblioteca",
    "skillCatalog": "Catálogo de Habilidades",
    "rankings": "Classificações",
    "searchCatalog": "Pesquisar catálogo...",
    "noSkillsMatch": "Nenhuma habilidade corresponde aos seus filtros.",
    "noEvaluations": "Nenhuma avaliação ainda",
    "runFirstEvaluation": "Execute sua primeira avaliação da Arena para começar a construir a classificação.",
    "skill": "Habilidade",
    "avgScore": "Pontuação Média",
    "tests": "Testes",
    "lastRun": "Última Execução",
    "librarySkill": "Habilidade da Biblioteca"
  },
  "itemView": {
    "itemSaved": "Item salvo",
    "failedToSave": "Falha ao salvar",
    "memoryArchived": "Memória arquivada",
    "memoryRestoredToActive": "Memória restaurada como ativa",
    "memoryPaused": "Memória pausada — oculta da busca",
    "failedToUpdateState": "Falha ao atualizar o estado",
    "itemDeleted": "Item deletado",
    "failedToDelete": "Falha ao deletar",
    "staleWarning": "Este item pode estar desatualizado — marcado como obsoleto pela manutenção",
    "conflictDetected": "Conflito detectado",
    "viewConflictingItem": "visualizar item conflitante",
    "conflictResolved": "Conflito resolvido — ambos os itens mantidos",
    "keepBoth": "Manter Ambos",
    "conflictResolvedOtherArchived": "Conflito resolvido — outro item arquivado",
    "keepThisArchiveOther": "Manter Este, Arquivar Outro",
    "thisItemArchived": "Este item foi arquivado",
    "archiveThis": "Arquivar Este",
    "tagsLabel": "Tags (separadas por vírgula)",
    "tagsPlaceholder": "tag1, tag2",
    "contentLabel": "Conteúdo",
    "relatedMemories": "Memórias relacionadas",
    "deleteItemTitle": "Deletar este item?",
    "deleteItemDescription": "Isso não pode ser desfeito. O item de conhecimento e todo seu conteúdo serão removidos permanentemente.",
    "deleting": "Deletando...",
    "projectLabel": "Projeto",
    "typeLabel": "Tipo",
    "statusLabel": "Status",
    "priorityLabel": "Prioridade",
    "assigneeLabel": "Atribuído a",
    "versionLabel": "Versão",
    "summarised": "Resumido",
    "used": "Usado",
    "timesSingular": "vez",
    "timesPlural": "vezes",
    "moreOptions": "Mais opções",
    "restoreToActive": "Restaurar como Ativo",
    "pause": "Pausar",
    "archive": "Arquivar"
  },
  "syncHistory": {
    "heading": "Histórico de sincronização",
    "backToSilo": "Voltar ao Silo",
    "noJobs": "Sem trabalhos de sincronização ainda",
    "cancelled": "Sincronização cancelada — o lote atual será concluído e parado",
    "finalising": "Finalizando…",
    "sourcePagesTip": "Páginas de origem escaneadas — não é o mesmo que adicionar itens ao silo",
    "src": "src",
    "itemsCreatedTip": "Novos itens adicionados ao silo",
    "itemsUpdatedTip": "Itens existentes atualizados",
    "itemsSkippedTip": "Itens inalterados pulados",
    "itemsDeletedTip": "Itens removidos do silo",
    "stopSync": "Parar sincronização",
    "jobId": "ID do trabalho",
    "parentSync": "Sincronização principal",
    "triggeredBy": "Acionado por",
    "duration": "Duração",
    "since": "Desde",
    "sinceLower": "desde",
    "items": "Itens",
    "new": "novo",
    "updated": "atualizado",
    "unchanged": "inalterado",
    "deleted": "deletado",
    "refused": "Recusados",
    "fileNotIndexed": "arquivo não indexado",
    "files": "arquivos não indexados",
    "labelled": "etiquetados",
    "error": "erro",
    "errors": "erros",
    "retrying": "Tentando novamente…",
    "retry": "Tentar novamente",
    "finalisingDetail": "Finalizando — verificando se nenhuma outra página permanece, então fechando o trabalho…",
    "scanningSource": "Escaneando origem…",
    "sourcePages": "páginas de origem",
    "sourcePageNote": "Páginas de origem escaneadas ≠ itens adicionados. As contagens de itens (+novo ~atualizado =inalterado) acumulam conforme cada lote é concluído.",
    "processing": "Processando…",
    "starting": "Iniciando… aguardando primeiro lote",
    "waitingForWorker": "Aguardando worker pegar o trabalho…",
    "stoppedBy": "Parado por {{user}} — páginas já ingeridas são mantidas",
    "user": "usuário"
  },
  "newSkill": {
    "skillCreated": "Habilidade \"{name}\" criada",
    "skillImported": "Importada \"{name}\"",
    "noSkillFilesFound": "Nenhum arquivo de habilidade .md encontrado neste repositório",
    "couldNotQueryGitHub": "Não foi possível consultar GitHub",
    "couldNotFetchSkill": "Não foi possível buscar a habilidade do GitHub",
    "invalidRef": "Referência inválida — use owner/repo/path/to/file.md",
    "couldNotFetchFile": "Não foi possível buscar o arquivo do GitHub",
    "pageTitle": "Nova Habilidade",
    "createTab": "Criar",
    "importTab": "Importar do GitHub",
    "nameLabel": "Nome *",
    "namePlaceholder": "code-review",
    "versionLabel": "Versão",
    "descriptionLabel": "Descrição",
    "descriptionPlaceholder": "Breve descrição do que faz essa habilidade",
    "contentLabel": "Conteúdo *",
    "categoriesLabel": "Categorias",
    "extraTagsLabel": "Tags adicionais",
    "optional": "(opcional)",
    "visibilityLabel": "Visibilidade",
    "pasteAnyOf": "Cole um desses:",
    "pasteUrlPlaceholder": "Cole uma URL do GitHub ou owner/repo/path…",
    "searchSpecificDirectory": "Pesquisar em um diretório específico",
    "customSearchPlaceholder": "ex. agents/ ou .claude/skills",
    "readyToImport": "Pronto para importar",
    "categoriesLabelImport": "Categorias",
    "optionalAddsToImportedTags": "(opcional, adiciona às tags importadas)",
    "visibilityAfterImport": "Visibilidade após importação",
    "importing": "Importando…",
    "importButton": "Importar Habilidade",
    "contentPlaceholder": "# Conteúdo da Habilidade\n\nDescreva aqui as instruções, prompts ou configuração da habilidade…",
    "creating": "Criando…",
    "createButton": "Criar Habilidade",
    "discovering": "Descobrindo…",
    "loading": "Carregando…",
    "discoverButton": "Descobrir",
    "previewButton": "Prévia",
    "searchButton": "Procurar",
    "notFoundSpecifyPath": "Não encontrado? Especificar caminho →",
    "importButtonLabel": "Importar Habilidade",
    "repoUrl": "URL do repositório",
    "directFileUrl": "URL direto do ficheiro"
  },
  "siloTimeline": {
    "mapNotGenerated": "Mapa de Inteligência de Plataforma ainda não gerado",
    "triggerSyncToBuild": "Acionue uma sincronização para gerá-lo.",
    "builtFromSnapshots": "Construído a partir de seus snapshots diários — envie alguns com `joyia memory sync git-log`, ou anexe uma integração do lado do servidor.",
    "platformMap": "Mapa de Inteligência de Plataforma",
    "historicalRecord": "Registro Histórico",
    "noSnapshotsYet": "Ainda não há snapshots diários. Acione uma sincronização para começar a ingerir.",
    "noSnapshotsPush": "Ainda não há snapshots diários. Envie-os do seu projeto com `joyia memory sync git-log`.",
    "seeded": "{{count}} elementos da cronograma inicializados",
    "seedTestData": "Inicializar dados de teste",
    "dailySnapshots": "Snapshots Diários",
    "windowDesc": "(janela móvel de 30 dias, dados mais antigos compactados em Registro Histórico)",
    "timelineExplorer": "Explorador de Cronograma",
    "updatedAgo": "Atualizado há {{time}}",
    "noContentYet": "Sem conteúdo ainda."
  },
  "syncConfig": {
    "dangerZone": "Zona de risco",
    "resetStoreTitle": "Reiniciar o armazenamento e recomeçar",
    "resetStoreDesc": "Elimina todos os itens importados e limpa os marcadores de sincronização. A configuração da origem é conservada. A próxima sincronização volta a importar tudo do zero.",
    "resetRestartBtn": "Reiniciar e recomeçar",
    "areYouSure": "Tem a certeza?",
    "resetting": "A reiniciar…",
    "yesReset": "Sim, reiniciar",
    "rebuildIndexTitle": "Reconstruir o índice de pesquisa",
    "rebuildIndexDesc": "Reconstrói a árvore de pesquisa semântica a partir dos itens que já existem neste silo. Nada é eliminado e nenhum conteúdo é perdido. Use isto se a pesquisa não devolver nada, ou se ao perguntar algo a este silo ele responder que «ainda não é pesquisável» sem haver nenhuma sincronização a correr: esse estado não se resolve sozinho. Também vale a pena executá-lo depois de uma importação em massa.",
    "indexing": "A indexar…",
    "queuing": "Em fila…",
    "rebuildIndexBtn": "Reconstruir o índice",
    "tokenHelp": {
      "confluence": "Criar um token de API da Atlassian",
      "jira": "Criar um token de API da Atlassian",
      "openwebui": "Criar uma chave de API em chat.joyia.p7s1.io (Settings → Account)",
      "gitlab": "Criar um token de acesso pessoal do GitLab",
      "github": "Criar um token de acesso pessoal do GitHub",
      "slack": "Criar uma aplicação do Slack e um token de bot",
      "teams": "Azure Portal → App registrations → Certificates & secrets",
      "sharepoint": "Azure Portal → App registrations → Certificates & secrets",
      "gdrive": "Google Cloud Console → Service Accounts → Keys"
    },
    "heading": "Configuração da sincronização",
    "syncHistory": "Histórico das sincronizações",
    "addSource": "Adicionar uma origem",
    "addIngestSource": "Adicionar uma origem de importação",
    "docAndTimelineConnectors": "Conectores de documentos e cronologia",
    "phBaseUrl": "URL base",
    "phApiToken": "Token de API",
    "phEmail": "E-mail",
    "phGitlabUrl": "URL base do GitLab (por exemplo, https://gitlab.com)",
    "phPersonalAccessToken": "Token de acesso pessoal",
    "phProjectPaths": "Chaves ou caminhos dos projetos (separados por vírgulas, por exemplo, mygroup/myrepo)",
    "phEnvironments": "Ambientes (opcionais, separados por vírgulas, por exemplo, production,staging)",
    "phDatadogApiKey": "Chave de API do Datadog",
    "createDatadogApiKey": "Criar uma chave de API do Datadog ↗",
    "phDatadogAppKey": "Chave de aplicação do Datadog",
    "createDatadogAppKey": "Criar uma chave de aplicação do Datadog ↗",
    "phDatadogSiteDefault": "Site (predefinição: datadoghq.eu)",
    "phServices": "Serviços (opcionais, separados por vírgulas)",
    "phFilterTags": "Etiquetas de filtro (opcionais, por exemplo, env:production)",
    "phGithubPatPlain": "Token de acesso pessoal do GitHub",
    "phRepositories": "Repositórios (separados por vírgulas, por exemplo, owner/repo, owner/repo2)",
    "phPagerdutyKey": "Chave da REST API do PagerDuty",
    "phServiceIds": "IDs dos serviços (opcionais, separados por vírgulas)",
    "phTeamIdsOptional": "IDs das equipas (opcionais, separados por vírgulas)",
    "phBotTokenXoxb": "Token OAuth do bot (xoxb-…)",
    "phChannelIdsLong": "IDs dos canais (separados por vírgulas, por exemplo, C0123456789, C9876543210)",
    "phWorkspaceLong": "Nome do espaço de trabalho (opcional, por exemplo, Acme Engineering)",
    "phTenantId": "ID do tenant do Azure AD",
    "phClientId": "ID de cliente do registo da aplicação",
    "phClientSecret": "Segredo de cliente",
    "phTeamIds": "IDs das equipas (separados por vírgulas)",
    "phSiteId": "ID do site (ou deixe vazio e use o URL do site abaixo)",
    "phSiteUrl": "URL do site (por exemplo, contoso.sharepoint.com:/sites/Engineering)",
    "resourceType": "Tipo de recurso:",
    "documentLibrary": "Biblioteca de documentos",
    "sharepointList": "Lista do SharePoint",
    "phListId": "ID da lista",
    "phDriveIdLong": "ID da unidade (opcional — por predefinição, a biblioteca de documentos do site)",
    "phFolderPathLong": "Caminho da pasta (opcional — subpasta à qual limitar a sincronização)",
    "phServiceAccountEmail": "E-mail da conta de serviço",
    "phPrivateKeyLong": "Chave privada (cole a chave PEM completa do JSON da conta de serviço)",
    "phFolderIdsLong": "IDs das pastas (separados por vírgulas — partilhe cada pasta com o e-mail da conta de serviço)",
    "entireSpaces": "Espaços inteiros",
    "phSpaceKeysLong": "Chaves dos espaços (separadas por vírgulas, por exemplo, ENG, DOCS)",
    "importsEveryPage": "Importa todas as páginas de cada espaço indicado.",
    "pageTrees": "Árvores de páginas",
    "phPageIds": "IDs das páginas (separados por vírgulas)",
    "phProjectKeysLong": "Chaves dos projetos (separadas por vírgulas, por exemplo, ENG, OPS)",
    "phIssueTypesLong": "Tipos de questão (opcionais, separados por vírgulas, por exemplo, Bug, Story)",
    "phJqlLong": "JQL personalizado (opcional — tem precedência sobre as chaves dos projetos)",
    "scheduleAuto": "Agendar a sincronização automática",
    "every6h": "A cada 6 h",
    "every12h": "A cada 12 h",
    "every24h": "A cada 24 h",
    "every48h": "A cada 48 h",
    "cancel": "Cancelar",
    "titleStopSync": "Parar a sincronização (o lote em curso termina e depois para)",
    "titlePreviewPage": "Pré-visualizar a página alterada mais recentemente",
    "titleDiscoverCount": "Descobrir o número real de páginas paginando o Confluence",
    "extractingWithAi": "A extrair e a resumir a página com IA…",
    "openInConfluence": "Abrir no Confluence ↗",
    "looksGoodStartSync": "Parece bem — iniciar a sincronização completa",
    "close": "Fechar",
    "tryAnotherPage": "Tentar outra página",
    "phSpaceKeysShort": "Chaves dos espaços (separadas por vírgulas)",
    "phProjectKeysShort": "Chaves dos projetos (separadas por vírgulas)",
    "phIssueTypesShort": "Tipos de questão (opcionais)",
    "phJqlShort": "JQL personalizado (opcional)",
    "phAccessTokenKeep": "Token de acesso (deixe vazio para manter o existente)",
    "phApiKeyKeep": "Chave de API (deixe vazio para manter a existente)",
    "phAppKeyKeep": "Chave de aplicação (deixe vazio para manter a existente)",
    "phDatadogSite": "Site (por exemplo, datadoghq.eu)",
    "phGithubPat": "Token de acesso pessoal do GitHub (deixe vazio para manter o existente)",
    "phRestApiKey": "Chave da REST API (deixe vazio para manter a existente)",
    "phBotToken": "Token OAuth do bot (deixe vazio para manter o existente)",
    "phChannelIds": "IDs dos canais (separados por vírgulas)",
    "phWorkspaceShort": "Nome do espaço de trabalho (opcional)",
    "phTenantIdKeep": "ID do tenant do Azure AD (deixe vazio para manter o existente)",
    "phClientIdKeep": "ID de cliente do registo da aplicação (deixe vazio para manter o existente)",
    "phClientSecretKeep": "Segredo de cliente (deixe vazio para manter o existente)",
    "noSitesFound": "Não foi encontrado nenhum site para esta ligação.",
    "phDriveIdShort": "ID da unidade (opcional)",
    "phFolderPathShort": "Caminho da pasta (opcional)",
    "browseFolders": "Explorar as pastas",
    "useThisFolder": "Usar esta pasta",
    "loading": "A carregar…",
    "emptyFolder": "Pasta vazia.",
    "phServiceAccountEmailKeep": "E-mail da conta de serviço (deixe vazio para manter o existente)",
    "phPrivateKeyKeep": "Chave privada (deixe vazio para manter a existente)",
    "phFolderIdsShort": "IDs das pastas (separados por vírgulas)",
    "enableWebhook": "Ativar a importação por webhook",
    "noIngestSources": "Ainda não há origens de importação configuradas",
    "addOpenwebuiOutputBtn": "Adicionar uma saída do OpenWebUI",
    "addOpenwebuiOutput": "Adicionar uma saída do OpenWebUI",
    "phOpenwebuiUrl": "URL base (por exemplo, https://chat.joyia.p7s1.io)",
    "phApiKey": "Chave de API",
    "phKnowledgeBaseIds": "IDs das bases de conhecimento (um por linha ou separados por vírgulas)",
    "addOutput": "Adicionar uma saída",
    "titleTriggerOutput": "Iniciar agora a sincronização da saída",
    "noOutputs": "Ainda não há saídas configuradas",
    "deleteSilo": "Eliminar este silo",
    "deleteSiloBtn": "Eliminar o silo",
    "thisIsPermanent": "Esta ação é definitiva!",
    "deleting": "A eliminar…",
    "testing": "A testar…",
    "testConnection": "Testar a ligação",
    "pagerDutyPath": "Na sua conta PagerDuty: {{path}}",
    "recommendedOwnAccount": "Recomendado: ligue-se com a sua própria conta Microsoft (não é necessário um administrador do Azure)",
    "orAppOnly": "Ou configure manualmente a autenticação app-only (requer que um administrador do Azure AD conceda acesso Sites.Selected):",
    "copyListId": "Obrigatório. Copie o ID da lista do SharePoint ou do Microsoft Graph Explorer.",
    "askToVerify": "Faça uma pergunta sobre esta página para verificar se a IA a compreendeu:",
    "fetchingConfluence": "A obter a página do Confluence e a resumi-la com IA…",
    "pickSiteFirst": "Escolha primeiro um site acima ou introduza um ID ou URL do site.",
    "deleteSiloWarning": "Elimina permanentemente o silo, todos os itens, a configuração de sincronização e os nós do grafo de conhecimento. Isto não pode ser anulado.",
    "raptorRebuildQueued": "Reconstrução de índice RAPTOR em fila – consulte o Histórico de sincronização para o progresso",
    "rebuildFailed": "Reconstrução falhou: {{error}}",
    "syncCancelled": "Sincronização cancelada – o lote atual terminará e depois parará",
    "cancelFailed": "Cancelamento falhou: {{error}}",
    "resetComplete": "Reposição concluída – {{deletedItems}} itens eliminados, {{sourcesReset}} fonte(s) limpa(s). Ative uma sincronização completa para reingerir.",
    "resetFailed": "Reposição falhou: {{error}}",
    "syncFailed": "Sincronização falhou: {{error}}",
    "outputSyncQueued": "Sincronização de saída em fila",
    "outputSyncFailed": "Sincronização de saída falhou: {{error}}",
    "sourceAdded": "Fonte adicionada",
    "failedToAddSource": "Falha ao adicionar a fonte: {{error}}",
    "sourceRemoved": "Fonte removida",
    "failedToRemoveSource": "Falha ao remover a fonte: {{error}}",
    "sourceUpdated": "Fonte atualizada",
    "failedToUpdateSource": "Falha ao atualizar a fonte: {{error}}",
    "enterBaseUrlAndApiKeyFirst": "Por favor, introduza primeiro o URL base e a chave API.",
    "connectedFoundKbsWithNames": "Conectado! {{count}} base(s) de conhecimento encontrada(s): {{names}}",
    "connectedFoundKbs": "Conectado! {{count}} base(s) de conhecimento encontrada(s).",
    "connectionFailed": "Conexão falhou: {{error}}",
    "outputAdded": "Saída adicionada",
    "failedToAddOutput": "Falha ao adicionar a saída: {{error}}",
    "outputRemoved": "Saída removida",
    "failedToRemoveOutput": "Falha ao remover a saída: {{error}}",
    "discoverFailed": "Descoberta falhou: {{error}}",
    "previewFailed": "Pré-visualização falhou: {{error}}",
    "askFailed": "Consulta falhou: {{error}}",
    "descSpaces": "espaços: {{keys}}",
    "descProjects": "projetos: {{keys}}",
    "descJql": "JQL: {{jql}}…",
    "descServices": "serviços: {{services}}",
    "descRepos": "repositórios: {{repos}}",
    "descTeams": "equipas: {{teams}}",
    "descChannels": "canais: {{channels}}",
    "descSyncedViaCli": "Sincronizado via Joyia CLI (joyia memory sync)",
    "descList": "lista: {{listId}}",
    "descListNoId": "lista (nenhum ID de lista definido)",
    "descFolder": "pasta: {{folderPath}}",
    "descNoSiteConfigured": "Nenhum site configurado",
    "descFolders": "pastas: {{folders}}",
    "descNoFoldersConfigured": "Nenhuma pasta configurada",
    "descNoUrlConfigured": "Nenhum URL configurado",
    "disableScheduledSync": "Desativar sincronização agendada",
    "enableScheduledSync": "Ativar sincronização agendada",
    "schedule": "agendamento",
    "cancelEdit": "Cancelar edição",
    "editSource": "Editar fonte",
    "incrementalSyncTitle": "Sincronização incremental (apenas alterações)",
    "fullSyncTitle": "Sincronização completa",
    "syncAlreadyRunning": "Sincronização já em curso",
    "forceFullResync": "Forçar ressincronização completa (todas as páginas)",
    "rawExcerptAiUnavailable": "Excerto bruto (IA indisponível)",
    "aiSummary": "Resumo da IA",
    "phAskPageQuestion": "p. ex. Qual é o tema principal desta página?",
    "webhookUrlCopied": "URL de webhook copiado",
    "copy": "Copiar",
    "yesDelete": "Sim, eliminar"
  },
  "connector": {
    "confluenceDesc": "Páginas e espaços",
    "jiraDesc": "Questões e projetos",
    "openwebuiDesc": "Base de conhecimento",
    "gitlabDesc": "Pipelines, merge requests e implementações",
    "datadogDesc": "Monitores e eventos",
    "githubDesc": "Actions, pull requests e lançamentos",
    "pagerdutyDesc": "Incidentes e piquete",
    "slackDesc": "Resumos dos canais e discussões",
    "teamsDesc": "Atividade dos canais",
    "local": "Local / CLI",
    "localDesc": "Ficheiros do projeto através da CLI joyia",
    "sharepointDesc": "Bibliotecas de documentos",
    "gdriveDesc": "Docs, Sheets e Slides",
    "confluence": "Confluence",
    "jira": "Jira",
    "openwebui": "OpenWebUI",
    "gitlab": "GitLab",
    "datadog": "Datadog",
    "github": "GitHub",
    "pagerduty": "PagerDuty",
    "slack": "Slack",
    "teams": "MS Teams",
    "sharepoint": "SharePoint",
    "gdrive": "Google Drive"
  },
  "siloTree": {
    "syncing": "A sincronizar…",
    "treeStats": "Estatísticas da árvore",
    "totalNodes": "Total de nós",
    "layers": "Camadas",
    "leafNodes": "Nós folha",
    "summaries": "Resumos",
    "legend": "Legenda",
    "leafChunk": "Fragmento folha",
    "treeExplorer": "Explorador da árvore",
    "loadingTree": "A carregar a árvore…",
    "failedToLoad": "Não foi possível carregar a árvore",
    "retry": "Repetir",
    "noTreeYet": "Ainda não foi construída nenhuma árvore RAPTOR",
    "triggerSync": "Inicie uma sincronização para construir o índice semântico.",
    "goToSilo": "Ir para o silo",
    "summarisedFrom_one": "Resumido a partir de {{count}} nó",
    "summarisedFrom_other": "Resumido a partir de {{count}} nós"
  },
  "createItem": {
    "addItem": "Adicionar um item de conhecimento",
    "title": "Título *",
    "phTitle": "Título do item",
    "content": "Conteúdo",
    "phContent": "Markdown suportado…",
    "knowledgeType": "Tipo de conhecimento",
    "typeAuto": "Deteção automática",
    "typeFactual": "Factual — documentos de referência, factos estáveis",
    "typeProcedural": "Procedimental — runbooks, guias práticos",
    "typeTemporal": "Temporal — eventos limitados no tempo, instantâneos",
    "typeRelational": "Relacional — dependências, arquitetura",
    "typeContextual": "Contextual — estado atual, incidentes",
    "typeSocial": "Social — estrutura da equipa, responsabilidades",
    "typePolicy": "Normativo — conformidade, SLA, governação",
    "typeMeta": "Meta — resumos, índices",
    "tags": "Etiquetas (separadas por vírgulas)",
    "suggestTags": "Sugerir etiquetas com IA a partir do título e do conteúdo"
  },
  "createSilo": {
    "startingLayout": "Estrutura inicial",
    "change": "Alterar",
    "tags": "Etiquetas (separadas por vírgulas)",
    "publicSilo": "Silo público",
    "publicSiloDesc": "Todas as pessoas da sua organização podem ler este silo",
    "guardrailProfiles": "Perfis de proteção",
    "guardrailDesc": "Aplica-se a todas as chamadas ao LLM que processam o conteúdo deste silo",
    "cancel": "Cancelar",
    "creating": "A criar…",
    "create": "Criar silo"
  },
  "errorBoundary": {
    "somethingWrong": "Algo correu mal",
    "unexpected": "Ocorreu um erro inesperado",
    "tryAgain": "Tente novamente",
    "goHome": "Ir para o início"
  },
  "siloShare": {
    "private": "Privado",
    "privateDesc": "Só você pode acceder",
    "restricted": "Restrito",
    "restrictedDesc": "As pessoas que convidar",
    "tribe": "Tribe",
    "tribeDesc": "Todos os membros de um tribe",
    "orgVisible": "Visível para a organização",
    "orgVisibleDesc": "Qualquer pessoa da sua organização",
    "shareSilo": "Partilhar o silo",
    "controlAccess": "Decida quem pode acceder a este silo de conhecimento.",
    "visibility": "Visibilidade",
    "selectTribes": "Escolha os tribes que podem ver este silo",
    "noTribes": "Não há tribes disponíveis",
    "selectAtLeastOne": "Escolha pelo menos um tribe para guardar",
    "pendingRequests": "Pedidos pendentes",
    "approve": "Aprovar",
    "deny": "Recusar",
    "peopleWithAccess": "Pessoas com acesso",
    "emailAddress": "Endereço de e-mail",
    "roleViewer": "Leitura",
    "roleEditor": "Edição",
    "invite": "Convidar",
    "youOwner": "Você (proprietário)",
    "owner": "Proprietário",
    "removeMember": "Remover o membro",
    "noMembers": "Ainda não há mais membros. Convide alguém acima."
  },
  "globalChat": {
    "suggestConnectSource": "Como ligo uma origem?",
    "suggestSiloVsSkill": "Qual é a diferença entre um silo e uma skill?",
    "askAi": "Perguntar à IA",
    "askKnowledgeBase": "Pergunte à sua base de conhecimento",
    "liveAccess": "Acesso em direto:",
    "askAboutKf": "Perguntar sobre o Knowledgeflow",
    "verifyBeforeActing": "As respostas vêm da documentação — verifique-as sempre antes de agir.",
    "closeChat": "Fechar o chat",
    "phAskKf": "Pergunte algo sobre o Knowledgeflow… (Enter para enviar)",
    "clearConversation": "Limpar a conversa",
    "yourKnowledge": "O seu conhecimento",
    "help": "Ajuda",
    "thisSilo": "Este silo",
    "allSilos": "Todos os silos",
    "searchingWithinThisSilo": "Pesquisando neste silo",
    "searchingAcrossAllSilos": "Pesquisando em todos os silos",
    "suggestMonitorsAlerting": "Que monitores estão ativos?",
    "suggestRecentEvents": "Mostrar eventos recentes",
    "suggestOpenMergeRequests": "Mostrar pedidos de fusão abertos",
    "suggestRecentPipelineStatus": "Estado recente do pipeline",
    "suggestIssuesInProgress": "Que problemas estão em curso?",
    "suggestTopicsCovered": "Que tópicos são abordados?",
    "suggestFindRecentItems": "Encontrar itens recentes",
    "suggestSummarizeSilo": "Resumir este silo",
    "phAskAllSilos": "Pergunte em todos os silos… (Enter para enviar)",
    "contentPolicies": "Políticas de conteúdo",
    "contentPoliciesActive": "Políticas de conteúdo (ativas)",
    "answerFromDocs": "Respondo a partir da documentação do Knowledgeflow."
  },
  "bundledFiles": {
    "heading": "Ficheiros incluídos",
    "phContents": "Conteúdo do ficheiro…"
  },
  "skillCard": {
    "viewSkill": "Ver a skill"
  },
  "carousel": {
    "prevSlide": "Diapositivo anterior",
    "nextSlide": "Diapositivo seguinte"
  },
  "agentElement": {
    "maxTurns": "Turnos máx."
  },
  "collab": {
    "settings": "Definições do Collab",
    "approvalMode": "Modo de aprovação",
    "maxTurnsPerPersona": "Turnos máximos por persona",
    "resetCounter": "Reiniciar o contador de turnos",
    "reset": "Reiniciar"
  },
  "connectionStatus": {
    "offline": "Sem ligação. Os valores não podem ser atualizados até voltar a estar online.",
    "reload": "Recarregar"
  },
  "helpAnswer": {
    "sources": "Fontes"
  },
  "helpWidget": {
    "clearAria": "Limpar a conversa",
    "clear": "Limpar a conversa",
    "closeAria": "Fechar a ajuda",
    "reading": "A ler a documentação…",
    "verifyNote": "As respostas vêm da documentação — verifique sempre antes de agir.",
    "productHelp": "Ajuda {{product}}",
    "productHelpDrag": "Ajuda {{product}} — arraste para mover",
    "answersFromDocs": "Respostas da documentação {{product}}",
    "askAbout": "Perguntas sobre {{product}}",
    "askAboutDetail": "Respondo a partir da documentação {{product}} e posso apontá-lo para o local correto.",
    "askAboutPlaceholder": "Perguntas sobre {{product}}…",
    "notAvailableYet": "A ajuda ainda não está disponível aqui.",
    "somethingWentWrong": "Algo correu mal (HTTP {{status}}).",
    "requestFailed": "O pedido falhou.",
    "couldNotRunAction": "Não foi possível {{action}}."
  },
  "citation": {
    "prevAria": "Anterior",
    "nextAria": "Seguinte"
  },
  "installPrompt": {
    "notNowAria": "Agora não",
    "iosPath": "Share → Add to Home Screen",
    "showMeHow": "Mostre-me como",
    "install": "Instalar"
  },
  "messageEditor": {
    "cancel": "Cancelar"
  },
  "message": {
    "copy": "Copiar a mensagem",
    "regenerate": "Gerar novamente a resposta",
    "edit": "Editar a mensagem",
    "goodResponse": "Boa resposta",
    "poorResponse": "Resposta fraca"
  },
  "plan": {
    "toggle": "Mostrar ou ocultar o plano"
  },
  "promptInput": {
    "removeAttachment": "Remover o anexo"
  },
  "reasoning": {
    "thinking": "A pensar…",
    "thoughtFor": "Pensou por alguns segundos",
    "thoughtForSeconds_one": "Pensou por {{count}} segundo",
    "thoughtForSeconds_other": "Pensou por {{count}} segundos"
  },
  "tool": {
    "streaming": "Em transmissão",
    "running": "Em execução",
    "approvalRequired": "Requer aprovação",
    "approved": "Aprovado",
    "completed": "Concluído",
    "denied": "Recusado",
    "error": "Erro",
    "pending": "Pendente"
  }
}
